// Common JS - loaded on all pages
import handleMobileMenu from './mobileMenu';
import handleStickyHeader from './stickyHeader';
import handleBodyClasses from './handleBodyClasses';
import objectFitPolyfill from './objectFitPolyfill';
import filterCategory from './filterCategory';
import ajaxLoadMore from './ajaxLoadMore';
import dropDownMenu from './dropDownMenu';

export default {
	/**
	 * Runs first before any JS
	 */
	init: () => {
		handleBodyClasses();
		handleStickyHeader();
		handleMobileMenu();
		filterCategory();
		ajaxLoadMore();
		dropDownMenu();
	},
	complete: () => {
		objectFitPolyfill();
	},
};
